<template>
  <div v-if="colors.length > 0" class="d-flex flex-wrap">
    <div
      v-for="color in filteredColors"
      :key="color.id"
      class="mr-2 mb-2"
    >
      <label
        class="d-inline-flex align-items-center justify-content-center rounded-circle"
        :style="{
          width: size + 'px',
          height: size + 'px',
          cursor: disabled ? 'cursor-not-allowed' : 'pointer',
          padding: '2px',
          boxSizing: 'border-box'
        }"
        :title="color.description"
      >
        <input
          type="checkbox"
          class="sr-only"
          :value="color"
          :checked="isSelected(color)"
          @change="toggleColor(color)"
          :disabled="disabled"
        />
        <div
          :style="colorStyle(color)"
          :class="{ 'opacity-50 cursor-not-allowed': disabled }"
        ></div>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ColorPicker',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Array,
      required: true
    },
    size: {
      type: Number,
      default: 36
    },
    borderGray: {
      type: String,
      default: '#DDDDDD'
    },
    borderBlue: {
      type: String,
      default: '#2563eb'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filteredColors () {
      return this.colors.filter(color => color.hex_code)
    }
  },
  methods: {
    isSelected (color) {
      return this.value.some(c => c.id === color.id)
    },

    toggleColor (color) {
      let selected = [...this.value]

      if (this.isSelected(color)) {
        selected = selected.filter(c => c.id !== color.id)
      } else {
        selected.push(color)
      }

      this.$emit('input', selected)
    },

    colorStyle (color) {
      const selected = this.isSelected(color)
      const isLight = this.needsBorder(color.hex_code)

      if (selected) {
        return {
          width: (this.size - 4) + 'px',
          height: (this.size - 4) + 'px',
          borderRadius: '50%',
          backgroundColor: color.hex_code,

          /* borda azul externa */
          border: `2px solid ${this.borderBlue}`,

          /* borda branca interna */
          boxShadow: 'inset 0 0 0 2px #ffffff'
        }
      }

      return {
        width: (this.size - 4) + 'px',
        height: (this.size - 4) + 'px',
        borderRadius: '50%',
        backgroundColor: color.hex_code,

        /* borda cinza mais grossa para cores claras */
        border: isLight
          ? `2px solid ${this.borderGray}`
          : 'none',

        boxShadow: 'none'
      }
    },
    hexToRgb (hex) {
      hex = hex.replace('#', '')
      return {
        r: parseInt(hex.substr(0, 2), 16),
        g: parseInt(hex.substr(2, 2), 16),
        b: parseInt(hex.substr(4, 2), 16)
      }
    },

    rgbToHsl (r, g, b) {
      r /= 255; g /= 255; b /= 255
      const max = Math.max(r, g, b)
      const min = Math.min(r, g, b)
      let h, s
      const l = (max + min) / 2

      if (max === min) {
        h = s = 0
      } else {
        const d = max - min
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
        switch (max) {
          case r: h = (g - b) / d + (g < b ? 6 : 1); break
          case g: h = (b - r) / d + 2; break
          case b: h = (r - g) / d + 4; break
        }
        h /= 6
      }

      return { h, s, l }
    },

    needsBorder (hex) {
      const { r, g, b } = this.hexToRgb(hex)
      const { s, l } = this.rgbToHsl(r, g, b)
      return l > 0.75 && s < 0.4
    }
  }
}
</script>

<style scoped>
</style>
